/*
レイヤーパネルに出す「表示開始ズーム」のうち、レイヤー実装の定数と実際の表示開始ズームが
異なるもの。レイヤーパネル（overlayGroups）と乖離リカバリーで寄せるズーム（searchSourceLayers）の
両方が同じ値を使うので、ここにまとめて片側だけ変わる事故を防ぐ
*/

// GEOSPACE 地番地図。レイヤーファイルの定義と異なるが、実際の表示に合わせる
export const GEOSPACE_CHIBAN_PANEL_MIN_ZOOM = 17;

// 役所地番地図（TRUSTART 地番図）
export const TRUSTART_CHIBAN_PANEL_MIN_ZOOM = 15;

// 登記所備付地図。低ズームでは対応エリアの塗りを表示する
export const REGISTRATION_MAP_PANEL_MIN_ZOOM = 7;
